// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__jU_yx","content":"GlobalSearch_content__Yqxj8"};